<!----Automotivehub Footer---->
<ng-container *ngIf="isPRW === undefined; else prwContentDap">
    <div class="footer">
        <div class="">
            <div class="container">
                <div class="footer-inner">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="logo-footer">
                                <div class="teaser lazyloaded" data-expand="-40" *ngIf="footerdata?.footerLogo">
                                    <a [routerLink]="['/']">
                                        <img id="logo-footer" loading="lazy" [src]="storeImagePath + footerdata?.footerLogo[0]?.footer_logo
                                    " alt="footer logo" class="center-block lazyloaded" fetchPriority="low" width="274" height="94">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div *ngIf="showFirstRowFooter" class="col-md-4 col-sm-12">
                            <div class="footer-content">
                                <ul class="list-inline mb-20 dark-links">
                                    <li *ngFor="let footer of footerdata?.links?.firstRow">
                                        <a (click)="onClickLinks($event,footer.menu_link)" target="_blank">
                                        {{footer.menu_name}}
                                    </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div *ngIf="showSecondRowFooter" class="col-md-4 col-sm-12">
                            <div class="footer-content">
                                <ul class="list-inline mb-20 dark-links career_links">
                                    <li *ngFor="let footer of footerdata?.links?.secondRow ">
                                        <a (click)="onClickLinks($event,footer.menu_link)" target="_blank" style="cursor: pointer;">
                                        {{footer.menu_name}}
                                    </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-12">
                            <div class="footer-content">
                                <div *ngIf="showSocialIconsCopyright">
                                    <div>
                                        <h2 class="title">Find Us</h2>
                                    </div>
                                    <div>
                                        <ul class="social-links circle animated-effect-1 margin-clear">
                                            <ng-container *ngFor="let footersocial of footerdata?.socialIconsCopyright || []">
                                                <li *ngIf="addIconClassName(footersocial.link_icon) !== 'copyright'" [class]="addIconClassName(footersocial.link_icon) === 'youtube-play' ? 'youtube' : addIconClassName(footersocial.link_icon)">
                                                    <a target="_blank" [href]="footersocial.menu_link | safe: 'resourceUrl'" [attr.aria-label]="footersocial.link_icon">
                                                        <i [class]="'fa fa-' + addIconClassName(footersocial.link_icon)"></i>
                                                    </a>
                                                </li>
                                            </ng-container>
                                        </ul>
                                    </div>
                                </div>
                                <div *ngIf="showContactDetails">
                                    <div *ngIf="footerdata">
                                        <h2 class="title">
                                            <a [routerLink]="['/contact-us']">
                                            {{footerdata?.contactDetails[firstObj]?.pretty_page_name }}
                                        </a>
                                        </h2>
                                    </div>
                                    <div [innerHtml]="footerdata?.contactDetails[firstObj]?.company_info"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="footerwarning!=false">
                    <div class=" col-lg-12 col-md-12 col-sm-12 text-center ">
                        <div class="footer-content ">
                            <div class="p65_warning ">
                                <a [attr.aria-label]="" href="https://www.p65warnings.ca.gov/ " target="_blank " class="btn btn-default text-white "> <img alt="" [src]="cdnImagePath + 'p65_warnings_icon.png'" class="img-responsive" loading="lazy" fetchPriority="low" /><span>Warning:</span> Cancer and Reproductive Harm - www.P65Warnings.ca.gov</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<!----PRW Power Footer---->

<ng-template #prwContentDap>
    <div class="footer">
        <div class="">
            <div class="container small-cont footer-container">
                <div class="footer-content text-center">
                    <ul class="list-inline">
                        <li>
                            <span class="help_title"> Need Help? </span> ASK ONE OF OUR EXPERTS :
                            <a class="link-dark" href="tel:951-436-7900"> 951-436-7900 </a>
                            <a class="link-dark" href="mailto:info@prwnetwork.com"> Contact Us </a>
                        </li>
                    </ul>
                </div>

                <div class="footer-inner">
                    <div class="row">
                        <!-- First Column -->
                        <div class="col-md-2 col-xs-12">
                            <div class="footer-content">
                                <ul class="list-inline mb-20 dark-links">
                                    <li *ngFor="let footer of footerdata?.links?.columns_1">
                                        <a (click)="onClickLinks($event,footer.menu_link)" target="_blank">
                                            {{footer.menu_name}}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <!-- Second Column -->
                        <div class="col-md-2 col-xs-12">
                            <div class="footer-content">
                                <ul class="list-inline mb-20 dark-links">
                                    <li *ngFor="let footer of footerdata?.links?.columns_2">
                                        <a (click)="onClickLinks($event,footer.menu_link)" target="_blank">
                                            {{footer.menu_name}}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <!-- Third Column -->
                        <div class="col-md-2 col-xs-12">
                            <div class="footer-content">
                                <ul class="list-inline mb-20 dark-links">
                                    <li *ngFor="let footer of footerdata?.links?.columns_3">
                                        <a (click)="onClickLinks($event,footer.menu_link)" target="_blank">
                                            {{footer.menu_name}}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <!-- Fourth Column -->
                        <div class="col-md-2 col-xs-12">
                            <div class="footer-content">
                                <ul class="list-inline mb-20 dark-links">
                                    <li *ngFor="let footer of footerdata?.links?.columns_4">
                                        <a (click)="onClickLinks($event,footer.menu_link)" target="_blank">
                                            {{footer.menu_name}}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <!-- Fifth Column -->
                        <div class="col-md-2 col-xs-12 footer_5">
                            <div class="footer-content">
                                <ul class="list-inline mb-20 dark-links">
                                    <li *ngFor="let footer of footerdata?.links?.columns_5">
                                        <a (click)="onClickLinks($event,footer.menu_link)" target="_blank">
                                            {{footer.menu_name}}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="">
            <ul class="social-links circle animated-effect-1">
                <ng-container *ngFor="let footersocial of footerdata?.socialIconsCopyright || []">
                    <li *ngIf="addIconClassNamePRW(footersocial.link_icon) !== 'copyright'" [class]="addIconClassNamePRW(footersocial.link_icon) === 'youtube-play' ? 'youtube' : addIconClassNamePRW(footersocial.link_icon)">
                        <a target="_blank" [href]="footersocial.menu_link | safe: 'resourceUrl'" [attr.aria-label]="footersocial.link_icon">
                            <i [class]="'fa fa-' + addIconClassNamePRW(footersocial.link_icon)"></i>
                        </a>
                    </li>
                </ng-container>
            </ul>
        </div>

        <!-- Footer Logo -->
        <div class="about_logo">
            <div class="logo-footer">
                <div class="teaser lazyloaded" data-expand="-40" *ngIf="footerdata?.footerLogo">
                    <a [routerLink]="['/']">
                        <img id="logo-footer " [src]="storeImagePath + footerdata?.footerLogo[0]?.footer_logo
                    " alt="footer logo" loading="lazy" class="center-block lazyloaded" fetchPriority="low" width="274" height="94">
                    </a>
                </div>
            </div>
        </div>
    </div>
</ng-template>